import React from "react";
import { Product } from "./Product";
import {CreditProductsInterface} from "../../interfaces/credit/credit-products.interface";

interface ProductsProps {
    products: CreditProductsInterface;
}

export const Products: React.FC<ProductsProps> = ({ products }) => {
    return (
        <>
            <div>
                { products.items.map(product => <Product key={ product.id } product={ product } />) }
            </div>
        </>
    )
}